import * as appointmentStatuses from 'modules/common/constants/appointmentStatuses';

export const APPOINTMENT_STATUS_TITLES = {
  undefined: {
    iconName: '',
    title: {
      id: 'const.unknown',
      defaultMessage: '** Unknown',
    },
  },
  [appointmentStatuses.COMPLETED]: {
    iconName: 'check',
    title: {
      id: 'Appointment.CloseReason.Completed',
      defaultMessage: '** Completed',
    },
  },
  [appointmentStatuses.CANCELED]: {
    iconName: 'naked-x',
    title: {
      id: 'Appointment.CloseReason.Canceled',
      defaultMessage: '** Cancelled',
    },
  },
  [appointmentStatuses.COULD_NOT_CONNECT]: {
    iconName: 'canceled-call',
    title: {
      id: 'Appointments.CloseAppointment.CloseDialog.Body.CloseReason.CouldNotConnectWithParticipants',
      defaultMessage: '** Could not contact',
    },
  },
};

